/**
 * hình thức hóa đơn
 */
export default {
  Cash: 'TM', // Tiền mặt
  Transfer: 'CK', // Chuyển khoản
  Undefined: 'TM/CK', // Chưa xác định được hình thức thanh toán
};
